<div part="header">
    <slot name="header"></slot>
</div>
<div part="content" class="bazis-layout-press-footer__content">
    <slot></slot>
</div>
<div part="footer">
    <slot name="footer"></slot>
</div>
